<template>
  <!-- Main modal -->
  <div
    class="fixed z-50 inset-0 overflow-y-auto transition-opacity bg-black bg-opacity-50 scrollbar-none"
  >
    <div
      class="relative top-10 p-2 mx-auto overflow-scroll scrollbar-none border sm:w-3/5 w-full shadow-lg rounded-md bg-white"
    >
      <!-- Modal content -->

      <button type="button" class="closing-btn mr-2" @click="$emit('close')">
        <svg
          class="w-5 h-5"
          fill="currentColor"
          viewBox="0 0 20 20"
          XMLns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clip-rule="evenodd"
          ></path>
        </svg>
      </button>

      <div class="flex flex-col content-end overflow-y-auto mt-10">
        <form @submit.prevent="handleExport">
          <!-- Modal header -->
          <div class="flex modal-title justify-center">
            <h3 class="">Esporta Conto Aperto</h3>
          </div>
          <!-- Fine Modal header -->

          <!-- Modal body -->
          <div class="py-3 px-2">
            <h2 class="tariff-subs">
              Seleziona periodo
            </h2>

            <div class="grid grid-cols-7 items-center px-4 mt-5 py-2">
              <div class="col-span-1 text-center font-bold">Da :</div>
              <input
                v-model="d1"
                type="date"
                class="col-span-2 custom-input"
              />
              <div class="col-span-1 text-center font-bold">A :</div>
              <input
                v-model="d2"
                type="date"
                class="col-span-2 custom-input"
              />
            </div>
          </div>
          

          <!-- Modal footer -->
          <div
            class="border-t-1 border-gray-400 w-full px-6 text-right flex justify-end items-end mb-2"
          >
            <div class="flex justify-end items-center mt-5">
              <button
                id="exportSubmitButton"
                type="submit"
                :class="[
                  export_active
                    ? 'orange-btn '
                    : 'orange-btn-disable_new', 'flex items-center gap-3'
                ]"
                :disabled="!export_active"
              >
                <svg
                  class="fill-current"
                  xmlns="http://www.w3.org/2000/svg"
                  height="1em"
                  viewBox="0 0 576 512"
                >
                  <!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                  <path
                    d="M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V288H216c-13.3 0-24 10.7-24 24s10.7 24 24 24H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM384 336V288H494.1l-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H384zm0-208H256V0L384 128z"
                  />
                </svg>
                Esporta
              </button>

              <button
                class="ml-3 gray-btn"
                type="button"
                @click="$emit('close')"
              >
                <span class="h-5"></span>
                Annulla
              </button>
            </div>
          </div>
          <!-- Fine Modal footer -->
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import axios from '../../gateway/backend-api'
import moment from 'moment'
import { useStore } from '@/store'

const today = moment().format('YYYY-MM-DD')
const store = useStore()


export default defineComponent({
  components: {},
  emits: ['close'],
  data() {
    return {
        d1: null,
        d2: today,
        export_active : false
    }
  },
  watch: {
    d1: function() {
      if(!this.d1 || !this.d2) {
        this.export_active = false
        return;
      }
      if(moment(this.d2).isBefore(this.d1)) {
        this.d1 = this.d2
        return;
      }
      this.export_active = true
      
    },
    d2: function() {
      if(!this.d1 || !this.d2) {
        this.export_active = false
        return;
      }
      if(moment(this.d2).isBefore(this.d1)) {
        this.d2 = this.d1
        return;
      }
      this.export_active = true
      
  },
  },
  methods: {
    handleExport() {
      console.log(moment(this.d1).toISOString(),this.d2)
      let payload = {
        start_date: moment(this.d1).toISOString(),
        end_date : moment(this.d2).add(1, 'days').toISOString()
      }
      store.dispatch('commonComponents/showLoadingModalAction')
      axios
            .post(
              '/' +
                localStorage.getItem('clinic') +
                '/account/export',
              payload,
              { responseType: 'blob' }
            )
            .then((res) => {
              console.log('res', res)
              var binaryData = []
              binaryData.push(res.data)
              let fileUrl = window.URL.createObjectURL(
                new Blob(binaryData, { type: 'application/vnd.ms-excel' })
              )
              
              let fileLink = document.createElement('a')
              fileLink.href = fileUrl
              
              fileLink.setAttribute('download', 'ContoAperto_'+moment().locale('it').format('DDMMYYYY') + '.xlsx')
              console.log('-')
              document.body.appendChild(fileLink)
              fileLink.click()
              
              store.dispatch('commonComponents/hideLoadingModalAction')
              store.dispatch('commonComponents/openNotificationModal', {
                  message: 'Documento creato'
                })
            })
            .catch(async function () {
              store.dispatch('commonComponents/hideLoadingModalAction')
              store.dispatch('commonComponents/openNotificationModal', {
                  message: 'Errore nella generazione, controllare i range inseriti'
                })
            })
    }
  }
})
</script>
